import Header from '../Header/Header';
import Footer from '../Footer';
import View from '../../../views';
import CartSidebar from '../CartSidebar/CartSidebar';
import FloatingCart from '../FloatingCart';
import GoogleAdsTracker from '../GoogleAdsTracker';
import useCartSidebar from '../../../utils/hooks/useCartSidebar';
import useLoginModal from '../../../utils/hooks/useLoginModal';

const Layout = () => {
  const { isOpen, openSidebar, closeSidebar } = useCartSidebar();
  const { openLogin } = useLoginModal();

  return (
    <div className="min-h-screen flex flex-col">
      <GoogleAdsTracker />
      {/* Solid covers for the status-bar and home-indicator safe-area strips */}
      <div className="safe-top-cover" aria-hidden="true" />
      <div className="safe-bottom-cover" aria-hidden="true" />
      <Header onCartClick={openSidebar} />
      <main className="flex-1">
        <View />
      </main>
      <Footer />

      {/* Cart Sidebar */}
      <CartSidebar
        isOpen={isOpen}
        onClose={closeSidebar}
        onLoginRequired={openLogin}
      />

      {/* Floating cart */}
      <FloatingCart onClick={openSidebar} />
    </div>
  );
};

export default Layout;
